<template>
  <div>
    <loader v-if="loading" />
    <div class="items-center justify-center flex flex-wrap px-4">
      <div class="my-3 w-full" >
        <zt-breadcrumbs :items="breadcrumbs" separator=">" />
      </div>
    </div>
    <div v-if="employeeInfo.personalInfo">
      <div class="flex px-4 flex-col sm:flex-row">
        <div
          class="card bg-white rounded shadow w-full sm:w-auto p-4 mb-6 mr-4 maxheight"
        >
          <zt-badge square :color="badgeColor()">{{ badgeText() }}</zt-badge>
          <div class="flex flex-col items-center p-4 px-16">
            <zt-avatar
              :text="
                employeeInfo.personalInfo.firstName
                  .trim()
                  .charAt(0)
                  .toUpperCase()
              "
              class="mr-3 mb-2"
              size="60px"
            />
            <div class="text-xl font-bold mb-2">
              {{
                `${employeeInfo.personalInfo.firstName} ${employeeInfo.personalInfo.lastName}`
              }}
            </div>
            <div class="text-gray-500">
              {{ employeeInfo.personalInfo.email }}
            </div>
          </div>
        </div>
        <div class="w-full sm:flex-1">
          <zt-tab class="ztab">
            <zt-tab-item v-if="permissionOnTab('314')"
              :label="$t('message.selfService.infoEmployee.tab.personalData')"
            >
              <employee-personal-info
                :personalData="employeeInfo.personalInfo"
              />
            </zt-tab-item>
            <zt-tab-item v-if="permissionOnTab('313')"
              :label="$t('message.selfService.infoEmployee.tab.contactData')"
            >
              <employee-contact-info :contactData="employeeInfo.dataContact" />
            </zt-tab-item>
            <zt-tab-item v-if="permissionOnTab('310')"
              :label="$t('message.selfService.infoEmployee.tab.addressData')"
            >
              <employee-address-info :addressData="employeeInfo.address" />
            </zt-tab-item>
            <zt-tab-item v-if="permissionOnTab('311')"
              :label="
                $t('message.selfService.infoEmployee.tab.identificationData')
              "
            >
              <employee-identify-info
                :dataIdentify="employeeInfo.identifyMyself"
              />
            </zt-tab-item>
            <zt-tab-item v-if="permissionOnTab('312')"
              :label="$t('message.selfService.infoEmployee.tab.bankData')"
            >
              <employee-bank-info :bankData="employeeInfo.bank" />
            </zt-tab-item>
            <zt-tab-item 
              v-if="employeeInfo.salaryHistory && permissionOnTab('315')"
              :label="$t('message.selfService.infoEmployee.tab.salary')"
            >
              <employee-salary-info :salaryData="employeeInfo.salaryHistory" />
            </zt-tab-item>
          </zt-tab>
        </div>
      </div>
    </div>
    <div v-if="!employeeInfo.personalInfo && !loading" class="flex justify-center items-center h-64">
      <div class="w-full md:w-2/3 m-6 py-6">
        <zt-alert color="info" filled :closeIcon="false">
          <template slot="custom-content">
            <div class="flex justify-start items-center">
              <zt-icon name="info-circle-solid" class="text-2xl mr-4"></zt-icon>
              <p>
                {{
                  $t('message.errorReference.SICHERN_PEOPLE_NOT_EXISTS')
                }}
              </p>
            </div>
          </template>
        </zt-alert>
      </div>
    </div>
  </div>
</template>

<script>
import EmployeeIdentifyInfo from './profile/EmployeeIdentifyInfo'
import EmployeeBankInfo from './profile/EmployeeBankInfo'
import EmployeeContactInfo from './profile/EmployeeContactInfo'
import EmployeePersonalInfo from './profile/EmployeePersonalInfo'
import EmployeeAddressInfo from './profile/EmployeeAddressInfo'
import EmployeeSalaryInfo from './profile/EmployeeSalaryInfo'
import Manager from '@/apiClient/Manager'
import moment from 'moment'
import Loader from '@/modules/Auth/components/loader'


export default {
  components: {
    EmployeeIdentifyInfo,
    EmployeeBankInfo,
    EmployeeContactInfo,
    EmployeePersonalInfo,
    EmployeeAddressInfo,
    EmployeeSalaryInfo,
    Loader
  },
  data() {
    return {
      idEmployee: '',
      employeeInfo: {},
      breadcrumbs: [
      {
        text: 'Inicio',
        to: '/dashboard',
        disabled: false
      }
    ],
      companyCountry: this.$store.state.locale,
      loading: true
    }

  },
  async created() {
    this.loading = true
    this.idEmployee = this.$route.params.id
    this.manager = new Manager()
    await this.getEmployeeInformation()
    this.breadcrumbsItems()
  },
  methods: {
    async getEmployeeInformation() {
      try {
        this.loading = true
        const {
          data: { data }
        } = await this.manager.getEmployeeInfo(this.idEmployee)
        this.employeeInfo = { ...data }
        const {
          fileNumber,
          birthDate,
          hireDate
        } = this.employeeInfo.personalInfo
        this.employeeInfo.personalInfo.fileNumber =
          fileNumber !== null ? fileNumber.toString() : ''
        this.employeeInfo.personalInfo.birthDate = this.formatDate(birthDate)
        this.employeeInfo.personalInfo.hireDate = this.formatDate(hireDate)
      } catch (error) {
        this.employeeInfo = {}
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : ''
    },
    badgeColor() {
      const companyStatus =
        this.employeeInfo &&
        this.employeeInfo.personalInfo &&
        this.employeeInfo.personalInfo.companyStatus
      return companyStatus === 0 || companyStatus === 3 ? 'F14181' : '379579'
    },
    badgeText() {
      const companyStatus =
        this.employeeInfo &&
        this.employeeInfo.personalInfo &&
        this.employeeInfo.personalInfo.companyStatus
      return companyStatus === 0 || companyStatus === 3
        ? this.$t('message.LicensesManager.search.userStatusUnactive')
        : this.$t('message.LicensesManager.search.userStatusActive')
    },
    breadcrumbsItems() {
      const { routerGoBack } = this.$route.params
      this.breadcrumbs.push({
      text: routerGoBack === 'myteam' ? this.$t('message.myTeam.shortName') : 'Lista de colaboradores',
      to: routerGoBack === 'myteam' ? '/myteam' : '/search',
      disabled: this.employeeInfo.personalInfo? false : true
    });
    if (this.employeeInfo.personalInfo) {
      this.breadcrumbs.push({
        text: `${this.employeeInfo.personalInfo.firstName} ${this.employeeInfo.personalInfo.lastName}`,
        to: '',
        disabled: true
      });
    }
    },
    permissionOnTab(id) {
      const actions = this.$store.state.actions;
      return actions && actions.length > 0 ? actions.some(act => act.id === id) : false;
    },
  }
}
</script>

<style lang="scss" scoped>
.maxheight {
  height: max-content;
}
::v-deep .ztab div ul {
  overflow-x: auto;
}
::v-deep
  .zt-breadcrumbs--disabled
  > .zt-breadcrumbs--item__link[data-v-471b517c] {
  color: #969696 !important;
}

::v-deep .zt-breadcrumbs--item__link[data-v-471b517c] {
  color: #028fef !important;
}
</style>
